import React, { useState, useEffect } from 'react';

const slidesData = [
  {
    image: '/assets/images/nextgen-banner-1-fb9ebf40dfa68b02e4cac74dd2c94870-1.webp',
    title: 'Reimagine Data Strategy with Gen AI',
    description: 'As a forward-thinking software development company in Dubai, we help you harness the power of AI through our specialized AI Center of Excellence. Our solutions improve scalability and drive stronger ROI. Get Started Today!',
    buttonText: 'Get Started Today!'
  },
  {
    image: '/assets/images/nextgen-banner-2-2de85d120098db153bd8c67b29f03e15-1.webp',
    title: 'AI Brilliance Made Simple',
    description: "Whether you're looking for custom app development services or full-scale AI solutions, we tailor every project to your needs. Our tech experts enable seamless AI practice management so your business stays ahead of the curve. Get Started Today!",
    buttonText: 'Get Started Today!'
  },
  {
    image: '/assets/images/nextgen-banner-3-2e75e618f6d4de358c0e381e1fb14b1a-1.webp',
    title: 'Accelerate Gen AI Integration',
    description: 'Integrate automation with a strategic approach. As a highly established web development company and AI partner, we provide strong data segmentation, machine learning practices, and MLOps that enhance AI effectiveness and streamline processes.',
    buttonText: 'Get Started Today!'
  }
];

function Slider({ setView }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isPaused, setIsPaused] = useState(false);

  const minSwipeDistance = 45;

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === slidesData.length - 1 ? 0 : prevIndex + 1));
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? slidesData.length - 1 : prevIndex - 1));
  };

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(() => {
      handleNext();
    }, 5500); // Auto-play sliding interval
    return () => clearInterval(timer);
  }, [currentIndex, isPaused]);

  // Touch swipe support for mobile
  const onTouchStart = (e) => {
    setIsPaused(true);
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    setIsPaused(false);
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe) {
      handleNext();
    } else if (isRightSwipe) {
      handlePrev();
    }
  };

  const handleCtaClick = (e) => {
    e.preventDefault();
    const contactForm = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    } else if (setView) {
      window.history.pushState({}, '', '/contact/');
      setView('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="slider-section">
      <div className="container">
        {/* Left-aligned Section Header Title */}
        <h2 className="slider-main-title">Smarter Solutions Through Artificial Intelligence</h2>
        
        <div 
          className="slider-wrapper"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          <div className="slider-slides-container">
            {/* Sliding Track for horizontal slide transitions */}
            <div 
              className="slider-track" 
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {slidesData.map((slide, index) => (
                <div 
                  className={`slider-slide ${index === currentIndex ? 'active' : ''}`} 
                  key={index}
                >
                  {/* Background Banner Image */}
                  <img 
                    src={slide.image} 
                    alt={slide.title} 
                    className="slider-img" 
                  />
                  
                  {/* Text overlay content */}
                  <div className="slide-overlay-content">
                    <h3 className="slide-title">{slide.title}</h3>
                    <p className="slide-desc">{slide.description}</p>
                    {slide.buttonText && (
                      <button className="btn-slide-action" onClick={handleCtaClick}>{slide.buttonText}</button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dots Indicator */}
          <div className="slider-dots">
            {slidesData.map((_, index) => (
              <button 
                key={index} 
                className={`slider-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Slider;
